import TextChatRoomItemFilter from "./TextChatRoomItem";
import CustomChatRoomItemFilter from "./CustomChatRoomItem";
import UnknownChatRoomItemFilter from "./UnknownChatRoomItem";
import UserAddedRoomItem from "./UserAddedRoomItem";
import BotStageChanged from "./BotStageChanged";
import ResultEventConfirmation from "./ResultEventConfirmation";
import ChatState from "./ChatState";
import UserChanged from "./UserChanged";
import ImageChatRoomItem from "./ImageChatRoomItem";
import AudioChatRoomItem from "./AudioChatRoomItem";
import DocumentChatRoomItem from "./DocumentChatRoomItem";
import QuestionnaireAnswered from "./QuestionnaireAnswered";
import NewQuestionnaire from "./NewQuestionnaire";
import BotStripeAccountStatus from "./BotStripeAccountStatus";
import EventConfirmChatRoomItem from "./EventConfirmChatRoomItem";
import UpdateUserStatus from "./UpdateUserStatus";
import ReceivedChatRoomItem from "./ReceivedChatRoomItem";
import AssignmentsPool from "./AssignmentsPool";
import VideoCallCreated from "./VideoCallCreated";
import VideoCallCompleted from "./VideoCallCompleted";
import ContractChanges from "./ContractChanges";
import ErrorDoubleConnection from "./ErrorDoubleConnection";
import UcsCode from "./UcsCode";
import ChatUpdate from "./ChatUpdate";

import type { EventFilter } from "@/Modules/Chat/WebSocketManager";

export default [
  ResultEventConfirmation,

  // Chat
  ChatUpdate,
  ReceivedChatRoomItem,
  UpdateUserStatus,
  UserChanged,
  ChatState,
  TextChatRoomItemFilter,
  ImageChatRoomItem,
  AudioChatRoomItem,
  DocumentChatRoomItem,
  CustomChatRoomItemFilter,
  UserAddedRoomItem,
  // be careful, you need to add all the text messages handlers before this line.
  UnknownChatRoomItemFilter,

  // Video Call
  VideoCallCreated,
  VideoCallCompleted,

  // Cloe
  BotStageChanged,
  EventConfirmChatRoomItem,

  //Promo code
  UcsCode,

  // Stripe
  BotStripeAccountStatus,

  // Questionnaries
  QuestionnaireAnswered,
  NewQuestionnaire,

  //AssignmentsPool
  AssignmentsPool,

  //LegalAgreements
  ContractChanges,

  //Errors
  ErrorDoubleConnection,
] as unknown as EventFilter[];
